export const N_COLUMNS = 50;
export let N_ROWS = 50;
export const INTERVAL = 1000;